export default {
  global: {
    more: '更多',
    title1: '晟然为安',
    title2: '生物医疗专利管理系统'
  },

  login: {
    login: '登录'
  },

  flow: {
    step: '步骤'
  },

  homes: {
    company: '公司',
    project: '项目',
    patent: '专利',
    process: '流程',
    /** card item */
    pendingMyApproval: '待我审批',
    pendingMyRequest: '提交待审批',
    overdueReminder: '逾期提醒',
    projectStatus: '项目状态',
    patentStatus: '专利状态',
    percentageOfCompanyTechnology: '技术领域分布',
    percentageOfProjectPhases: '项目阶段分布',
    patentsTop10: '专利国家排名前10',
    /**  */
    companyProcess: '公司流程',
    projectProcess: '项目流程'
  },

  /* 菜单 */
  menu: {
    home: '首页',
    homes: {
      toolManagerHome: '系统管理员',
      companyManagerHome: '公司管理员',
      projectManagerHome: '项目管理员',
      countryManagerHome: '专利管理员'//'国家专利管理员'
    },
    patentManagement: '专利管理',
    generalProcessManagement: '通用流程',
    processApprovalManagement: '审批流程',
    templateManagement: '文件管理',
    adminManagement: '系统管理',
    viewCompanyInfo: '查看公司信息',
    addGeneralProcess: '新增通用流程',
    editGeneralProcess: '编辑通用流程',
    viewGeneralProcess: '查看通用流程',
    updateCompanyInfo: '完善公司信息',
    companyManagement: '公司管理',
    projectManagement: '项目管理',
    userDataAccess: '项目授权',
    templateLibrary: '文件库',
    accountManagement: '账号管理',
    roleManagement: '角色管理',
    roleGrantAuthorization: '角色授权',
    messageManagement: '消息管理',
    dataDictionary: '数据字典',
    editCompanyProcess: '编辑公司流程',
    viewCompanyProcess: '查看公司流程',
    companyProcessAuditList: '公司流程审核列表',
    auditCompanyProcess: '审核公司流程',
    viewCompanyProcessAudit: '公司流程审核查看',
    editProjectProcess: '编辑项目流程',
    viewProjectProcess: '查看项目流程',
    approvalCompanyProcess: '公司流程审批',
    approvalProjectProcess: '项目流程审批',
    projectProcessAuditList: '项目流程审核列表',
    auditProjectProcess: '审核项目流程',
    viewProjectProcessAudit: '项目流程审核查看',
    patentAdd: '新增专利',
    patentEdit: '编辑专利',
    patentView: '查看专利',
    projectProcessExcute: '项目流程执行',
    companyInfoView: '查看公司信息',
    companyInformationView: '更新公司基本信息',
    generalProcessAdd: '新增通用流程',
    generalProcessEdit: '编辑通用流程',
    generalProcessView: '查看通用流程',
    generalProcessCopy: '复制通用流程',
    companyProcessEdit: '编辑公司流程',
    companyProcessView: '查看公司流程',
    companyProcessListView: '公司流程列表',
    projectProcessEdit: '编辑项目流程',
    projectProcessView: '查看项目流程',
    privilegeManagement: '权限管理',
    accountManagementDetails: '账户管理详情',
    roleManagementDetails: '角色管理详情',
    dataDictionaryDetails: '数据字典详情',
    projectAddEditView: '项目维护',
    projectAdd: '项目新增',
    projectView: '项目查看',
    projectUpdatePlanView: '项目计划更新',
    projectUserDataViewDetail: '项目用户数据授权',
    stationNews: '站内消息',
    stationNewsDetails: '站内消息详情',
    changePassword: '修改密码',
    patentEmpower:'专利授权'
  },

  /* 按钮 */
  button: {
    add: '新增',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    search: '搜索',
    reset: '重置',
    cancel: '取消',
    next: '下一步',
    previousStep: '上一步',
    save: '保存',
    submit: '提交',
    upload: '上传',
    import: '导入',
    enable: '启用',
    disable: '禁用',
    return: '返回',
    process: '过程',
    viewProcess: '查看流程',
    editProcess: '编辑流程',
    generate: '报表',
    revoke: '撤销',
    sync: '同步',
    addNode: '增加文件夹',
    addChildNode: '增加子文件夹',
    deleteNode: '删除文件夹',
    deleteFile: '删除文件',
    uploadFile: '上传文件',
    createFolder:'创建文件夹',
    editFolder:'编辑文件夹',
    deleteFolder:'删除文件夹',
    copyLink:'复制链接',
    assign: '授权',
    send: '发送',
    resubmit: '重新提交',
    approve: '批准',
    reject: '拒绝',
    sure: '确定',
    confirm: '确认',
    importTemplateDownload: '导入模板下载',
    plan: '计划',
    implementing: '执行',
    download: '下载',
    allSelect: '全选',
    reverseSelect: '反选',
    cancelSelect: '取消选择',
    scan: '浏览',
    authorize: '授权',
    updateSchedule:'更新日程',
    viewSchedule:"查看日程",
    schedule: '计划',
    push: '推送',
    timeline: '计划',
    copy: '复制'
  },

  /* 公共信息 */
  messageCommon: {
    success: '成功',
    failed: '失败',
    error: '错误',
    noData: '暂无数据',
    operateSuccess: '操作成功',
    operateError: '操作失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    selectAtLeastOne: '至少选择一条记录',
    confirmDelete: '确认删除吗',
    latestStepIsUnchecked: '最新的项目流程不是通过状态，您是否确认继续',
    request: '请求',
    tips: '提示',
    beEmpty: '为空',
    beMandatory: '是必需的',
    noSelect: '未选择',
    greaterThan: '大于',
    lessThan: '小于',
    greaterThanOrEqualTo: '大于等于',
    lessThanOrEqualTo: '小于等于',
    startTime: '开始时间',
    endTime: '结束时间',
    confirmOverwriteAfterSync: '同步成功后将覆盖已修改过的信息，是否继续？',
    confirmOnlyEmptyInfoAfterSync: '同步成功后将仅重写为空的字段信息，是否继续？',
    confirmFormatter: '确认{0}吗',
    lengthSectionFormatter: '长度在 {0} 到 {1} 个字符',
    articleStepsErrorFormatter: '第{0}步，{1}{2}',
    articleRecordsErrorFormatter: '第{0}条记录，{1}{2}',
    articleStepsRecordsErrorFormatter: '第{0}步，第{1}条记录，{2}{3}',
    articleLinesInTableErrorFormatter: '{0}，第{1}行，{2}{3}',
    onlyExtensions: '只能上传扩展名为{0}的文件',
    fileMaxSize: '只能上传小于{0}M的文件',
    itemTipWithName: '{0}：{1}的{2}{3}',
    itemCompareTipWithName: '{0}：{1}的{2}必须{3}{0}：{4}的{2}',
    itemCompareTipWithName2: '{0}的{1}必须{2}{3}的{1}',
    beEmptyFormatter: '{0}为空',
    noSelectFormatter: '{0}未选择',
    sync: '同步',
    successFormatter: '{0}成功',
    failedFormatter: '{0}失败',
    errorFormatter: '{0}错误'
  },

  /* 查询 form*/
  queryForm: {
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    selectDate: '选择日期',
    companyName: '公司名称',
    processName: '流程名称',
    technicalArea: '技术领域',
    headQuarter: '总部',
    companyContractPerson: '公司联系人',
    status: '状态',
    projectName: '项目名称',
    patentObjective: '专利目标',
    patentType: '专利类型',
    country: '国家',
    patentAppNo: '专利申请号',
    applyStartDate: '申请日期开始',
    applyEndDate: '申请日期结束',
    submitStartDate: '提交开始日期',
    submitEndTime: '提交结束日期',
    title: '标题',
    content: '内容',
    sendDate: '发送日期',
    waitAudit: '待审批',
    approve: '通过',
    reject: '拒绝',
    draft: '草稿',
    createdBy: '创建人',
    createdTime: '创建时间',
    enable: '启用',
    disable: '禁用',
    fllingStartDate: '申请日期开始',
    fllingEndDate: '申请日期结束',
    composition: '组成',
    formulation: '配方',
    process: '过程',
    dosage: '剂量',
    use: '使用',
    others: '其它',
    inProsecution: '诉讼中',
    grant: '已授权',
    inactive: '无效',
    expired: '过期',
    autoGenerate: '自动生成',
    userName: '用户名称',
    companyEmail: '公司邮箱',
    roleName: '角色名称',
    state: '状态',
    authorized: '已授权',
    notAuthorized: '未授权',
    keywords: '关键字',
    dueDateNotification: '到期通知',
    systemNotification: '系统通知',
    projectCode: '项目代码',
    projectDevelopmentStatus: '项目阶段状态',
    mobilePhone: '手机号码',
    noStart: '未开启',
    inProgress: '进行中',
    completed: '已完成',
    whetherTheOverdue: '是否逾期',
    yes: '是',
    no: '否',
    isAvaliable: '是否有效',
    pendingForApproval: '待审批',
    approved: '通过',
    rejected: '拒绝',
    all: '所有',
    representative: '代表',
    member: '成员'
  },

  /* table Form || form 表单*/
  formData: {
    companyProcessInformation: '公司流程信息',
    processName: '流程名称',
    phaseName: '项目阶段',
    approve: '审核',
    view: '查看',
    technicalArea: '技术领域',
    status: '状态',
    createdBy: '创建人',
    createdTime: '创建时间',
    preliminaryResearch: '初步研究',
    action: '操作',
    comment: '意见',
    approvalComment: '审核意见',
    approvalHistoryLog: '审核历史记录',
    reason: '审核意见',
    time: '时间',
    companyCode: '公司编号',
    companyName: '公司名称',
    entityType: '企业类型',
    headQuarter: '总部',
    numberOfEmployees: '员工人数',
    annualRevenue: '年销售额',
    companyLegalPerson: '公司法人',
    companyCEO: '公司CEO',
    companyContactPerson: '公司联系人',
    mobilePhone: '手机号码',
    companyPhone: '公司电话',
    companyAddress: '公司地址',
    companyDetailAddress: '详细地址',
    remarks: '备注',
    uploadFile: '上传文件',
    projectCount: '项目统计',
    tips: '提示',
    pleaseInsertRejectReason: '请输入拒绝理由',
    pass: '通过',
    reject: '拒绝',
    submit: '提交',
    systemSync: '系统同步',
    enable: '启用',
    disable: '禁用',
    projectName: '项目名称',
    patentCode: '专利编号',
    patentObjective: '专利目标',
    patentType: '专利类型',
    country: '专利国家',
    patentAppNo: '专利申请号',
    filingDate: '申请日期',
    isAvaliable: '是否有效',
    isAvaliable2: '是否可用',
    projectPhase: '项目阶段',
    patentStatus: '专利状态',
    prosecution: '申请战略概要',
    docketNumber: '本公司专利号',
    prosecutionActions: '起诉行为',
    marketAuthorizationDate: '市场授权日期',
    priorityList: '专利受理列表',
    publicationNumber: '专利公布号',
    publicationDate: '公布日期',
    grantPatentNo: '专利授权号',
    grantDate: '授权日期',
    expiryDate: '过期日期',
    expiryExpectedDate: '过期日期/预计到期日',
    familyMembers: '专利家庭成员',
    no: '序号',
    activity: '行为',
    priorityNumber: '受理编号',
    priorityDate: '受理日期',
    userName: '用户名称',
    companyEmail: '公司邮箱',
    roleName: '角色名称',
    telephone: '电话',
    estimatedStartDate: '预估开始时间',
    estimatedEndDate: '预估结束时间',
    stepName: '步骤名称',
    introduction: '简介',
    projectDevelopmentStatus: '项目阶段状态',
    projectCode: '项目代码',
    keywords: '关键字',
    patentCount: '专利数量',
    productNameResearchCode: '产品名称/研究代码',
    isThisInlicensed: '是否有执照？',
    contactIsAttached: '是否有相关附件？',
    indicationTherapeuticArea: '适应症（治疗区）',
    summaryofthetechnical: '本发明技术内容概要',
    inventionDisclosure: '发明披露',
    isAvaliable1: '是否有效吗？',
    relevantDocumentSearch: '相关文档搜索',
    literature: '文献',
    patent: '专利',
    author: '作者',
    title: '标题',
    publication: '刊物名称',
    date: '时间',
    attachment: '附件',
    patentNo: '专利号',
    patentOwner: '专利所属人',
    projectStartStatus: '项目启动状态',
    through: '通过',
    refusedTo: '拒绝',
    pending: '待审批',
    theDraft: '草稿',
    introductionLower: '简介',
    nameEn: '英文名称',
    generalInformation: '基本信息',
    patentInformation: '专利信息',
    familyMemberInformation: '家庭成员信息',
    devStage: '项目阶段',
    legalStatus: '专利状态',
    SRBMPatentCode: '专利编号',
    appNo: '专利申请号',
    publicationNo: '专利公布号',
    grantNo: '专利授权号',
    priorityCountry: '专利国家',
    priorityAppNo: '受理编号',
    priorityAppDate: '受理日期',
    schedule: '日程',
    isOnlyMainPatent: '是否只查看销售代表',
    patentCategory: '专利类别'
  },

  checkList: {
    upload: '上传',
    pleaseEnter: '请输入',
    attachments: '附件',
    inProgress: '进行中',
    done: '已完成',
    na: '不适用',
    generalAttachment: '流程附件',
    projectAttachment: '项目附件',
    areYouSureToDelete: '你是否确认删除该流程？',
    tips: '提示',
    confirm: '确认',
    cancel: '取消',
    deleteSuccessful: '删除成功',
    pleaseUploadChecklistFile: '请上传Checklist文件',
    onlyExtensions: '只能上传扩展名为{0}的文件',
    fileMaxSize: '只能上传小于{0}M的文件',
    schedule:"日程",
    pleaseInsertSchedule:"请输入日程",
    pleaseInsertExplain:"请输入说明",
    pleaseInsertLink:"请输入链接",
    linkName:"链接名称",
    hyperlink:"链接地址",
    addLink:"链接",
    pleaseInsertLinkName:"请输入链接名称",
    pleaseInsertHyperlink:"请输入链接地址",
    downloading:"正在下载"
  },

  CompanyAuditView: {
    companyName: '公司名称',
    technicalArea: '技术领域',
    status: '状态',
    submitStartDate: '提交开始时间',
    submitEndTime: '提交结束时间',
    processName: '流程名称',
    approve: '审核',
    view: '查看',
    createdBy: '创建人',
    createdTime: '创建时间',
    preliminaryResearch: '初步研究',
    action: '操作',
    approvalComment: '审核意见',
    approvalHistoryLog: '审核历史记录',
    reason: '审核意见',
    time: '时间'
  },

  fileLibrary:{
    createSubfolder:'创建子文件夹',
    editFolder:'编辑文件夹',
    deleteFolder:'删除文件夹',
    search:{
      m1:'不包含子目录',
      m2:'包含子目录',
      placeholder:'请输入关键字'
    },
    button:{
      copyLink:'复制链接',
      download:'下载文件',
      deleteFile:'删除文件'
    },
    tip:{
      dirFirst:'请先选择一个目录',
      copy:'链接地址已复制到剪贴板',
      fileNameExsit:"文件名已存在是否覆盖原文件，如不覆盖请修改文件名称重新上传",
      fileNameExsitNoAccess:"文件名已存在并且没有权限访问原文件，请修改文件名之后在上传"
    },
    form:{
      createSubfolder:'创建子文件夹',
      editFolder:'编辑文件夹',
      folderName:'文件夹名称',
      description:'描述'
    }
  },

  administration: {
    whole: '全部',
    effective: '有效',
    invalid: '无效',
    userPhoto: '用户头像',
    assign: '授权',
    Usermobilephone: '用户手机',
    customertype: '用户类型',
    Superadministrator: '超级管理员',
    system: '系统',
    company: '公司',
    project: '项目',
    patent: '专利',
    role: '角色',
    deleteAccount: '是否要删除此账号？',
    selectAccount: '请选择用户账户',
    resetPassword: '是否要批量重置密码（初始密码：123456）?',
    deleteAccounts: '是否要批量删除账户?',
    batchEnabled: '是否要批量启用?',
    batchDisable: '是否要批量禁用?',
    roleDescription: '角色描述',
    roleStatus: '角色状态',
    business: '业务',
    key: '键',
    value: '值',
    enValue: '英文值',
    chValue: '中文值',
    enumerationName: '枚举名称',
    describe: '描述',
    dicValue: '值',
    dicTypeName: '类型名',
    dicSeq: '序列',
    sort: '排序',
    projectDevelopmentStatus: '流程阶段',
    authorized: '已授权',
    unauthorized: '未授权',
    projectCode: '项目代码',
    fileName: '文件名',
    browseTemplates: '浏览模板',
    isIncludeChild: '包含子级',
    templateType: '模板类型',
    FileName: '文件名',
    FileSize: '文件大小',
    modifiedtemplatename: '请输入修改的模板名称',
    beAdded: '请选择需要添加模板类型的位置',
    entertemplatename: '请输入模板名称',
    Deletetype: '是否删除所选的模板类型',
    Deletefile: '是否删除所选的模板文件',
    selectfile: '请选择模板文件',
    batchdeletefiles: '是否要批量删除模板文件',
    uploadseat: '请选择需要上传模板文件的位置',
    paw: '密码',
    verificationCode: '验证码',
    getCode: '获取验证码',
    automaticLogin: '8小时自动登录',
    userNameempty: '用户名不能为空',
    usermailboxempty: '用户邮箱不能为空',
    pawnot: '密码不能为空',
    codenot: '验证码不能为空',
    OldPassword: '旧密码',
    NewPassword: '新密码',
    ConfirmPassword: '确认密码',
    xentepassword: '请输入旧密码',
    xentenewpassword: '请输入新密码',
    xentenewthepassword: '请输入确认密码',
    pwdpism: '两次密码不一致，请重新输入',
    authorizationbatch: '是否要批量取消授权',
    authorizationnot: '是否要批量授权',
    Incorrectmailboxformat: '邮箱格式不正确',
    Incorrectmobilenumber: '手机号码格式不正确',
    PleaseuserAvatar: '请输入用户头像',
    uploadedpicture: '上传头像图片大小不能超过 10MB!',
    Pleaseselectarole: '请选择角色',
    deleteroles: '是否要批量删除角色?',
    pawTesting: '密码必须是8到12位，且包含大小写字母和数字',
    Logout: '退出登录',
    Noauthority: '该用户拥有公司/系统所有权限，不需要额外分配',
    Companymailbox: '公司邮箱不能为空',
    format: '上传头像图片只能是 .jpg,.png,.jpeg,.gif,.tif,.bmp 格式!',
    manmgeuploadedpicture: '上传头像图片大小不能超过 200MB!',
    inputcharacters: '请输入1～50个字符',
    confirmtooverwrite: '是否确认覆盖',
    Approvalstatus: '审批状态',
    projectStatus: '项目状态',
    Rejected: '已拒绝',
    Notyetbegun: '未开始',
    roleType: '角色类型'
  },

  tipsList: {
    companyToDisable: '请选择要禁用的公司！',
    companyToEnable: '请选择要启用的公司！',
    youWantToDelete: '请选择要删除的公司！',
    deleteCompanyWill: '删除公司会同步删除公司下所有项目、流程、专利信息，是否确认删除！',
    deleteProjectWill: '删除项目会同步删除项目下所关联的流程、checklist、专利信息，是否确认删除！',
    deleteTheSuccess: '删除成功！',
    deleteFailed: '删除失败！',
    pleaseSelectUser: '请选择用户！',
    youWantUserAuthorization: '您确定要进行用户授权么！',
    youWantToUndoTheUser: '您确定要进行撤销用户么！',
    pleaseSelectTheFile: '请选择符合类型的文件，参考类型：',
    LicenseFilesNotUploaded: '执照相关附件未上传',
    companyProcessInAppToCreateProject: '公司流程正在审批中，是否基于前一个已审批通过的流程创建项目？',
    patentCountryAppNoExist: '专利国家：{0}，专利申请号：{1}的专利已存在于家庭成员中',
    confirmEmptyInfoAndOverwrittenFMListAfterSync: '同步成功后将重写为空的专利信息，并且覆盖家庭成员信息，是否继续？',
    confirmOnlyEmptyInfoAfterSync: '同步成功后将重写为空的专利信息，是否继续？',
    confirmEmptyInfoAndUpdateFMListAfterSync: '同步成功后将重写为空的专利信息，并且更新家庭成员信息，是否继续？'
  }

}
